import React from 'react';

import { ModalProvider } from '../context/ModalContext';

import GTM from './GTM';
import Layoutv2 from './Layout/Layoutv2';

const Layout = ({ children, ...otherProps }) => (
    <ModalProvider>
        <GTM />
        <Layoutv2 {...otherProps}>{children}</Layoutv2>
    </ModalProvider>
);
export default Layout;
